export default class SvgIconPath {
    static lineChartLegend = 'path://M9.06,1.4c2.21,0,4,1.79,4,4s-1.79,4-4,4-4-1.79-4-4S6.85,1.4,9.06,1.4ZM.34,9.9L15.8,.15c.39-.25,.98-.18,1.3,.16h0c.32,.33,.27,.81-.13,1.06L1.51,11.11c-.39,.25-.98,.18-1.3-.16h0c-.32-.33-.27-.81,.13-1.06Z';
    
}